<template>
  <div class="login">
    <div class="login_inner">
      <div class="l_inner"></div>
      <div class="r_inner">
        <div class="item_box">
          <!-- <h3 class="center">登 录</h3>
          <h4>欢迎登录，{{ $store.projectData.title }}</h4> -->
          <h5 class="center">{{ $store.projectData.title }}</h5>
          <div class="item item1">
            <div class="icon icon-user"></div>
            <input type="text" v-model="LoginNo" placeholder="用户名" autocomplete="off" prop="LoginNo" data-mode="en" />
          </div>
          <div class="item item2">
            <div class="icon icon-password"></div>
            <input @keyup.enter="handleLogin" type="password" v-model="Password" prop="Password" data-mode="en"
                   placeholder="密码" maxlength="15" oncopy="return false" oncut="return false" onpaste="return false" />
          </div>
          <div class="handle_inner">
            <el-checkbox v-model="memory" class="mini">记住密码</el-checkbox>
          </div>
          <button @click="handleLogin" class="btn_inner login_btn">
            登 录
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { encode, decode } from '@/utils/base64'
import api_user from '@/api/user'
import version from '@/version/version.json'

export default {
  data () {
    return {
      LoginNo: '',
      Password: '',
      memory: false
    }
  },
  watch: {
    memory (n) {
      if (!n) {
        localStorage.removeItem('loadingCondition')
      }
    }
  },
  created () {
    // 清空所有会话存储
    sessionStorage.clear()

    const loadingCondition = JSON.parse(decode(localStorage.getItem('loadingCondition')) || null)
    if (loadingCondition) {
      this.memory = true
      this.LoginNo = loadingCondition[0]
      this.Password = loadingCondition[1]
    }

    if (!this.LoginNo && !this.Password && process.env.NODE_ENV === 'development') {
      this.LoginNo = 'St00001'
      this.Password = '888888'
    }
  },
  mounted () {
    // 版本信息
    console.log(version)
  },
  methods: {
    // 登录
    handleLogin () {
      if (this.LoginNo && this.Password) {
        api_user.Login({
          account: this.LoginNo,
          password: this.Password
        }).then(res => {
          if (res.isSucceed) {
            sessionStorage.setItem('token', res.result.token) // 用户标识

            // 用户信息临时保存
            sessionStorage.setItem('userInfo', encode(JSON.stringify({
              userID: res.result.uid,
              userType: res.result.userType,
              userName: res.result.name,
              account: res.result.account,
              pic: res.result.headPic_Url
            })))

            // 是否保存密码
            if (this.memory) {
              localStorage.setItem('loadingCondition', encode(JSON.stringify([this.LoginNo, this.Password])))
            }

            if (res.result.userType == 1) {
              this.$message({
                type: 'warning',
                message: '管理员账号请至管理端登录'
              })
            } else if (res.result.userType == 2) {
              // 教师
              window.location.href = 'teacher.html'
            } else if (res.result.userType == 3) {
              // 学生
              window.location.href = 'student.html'
            } else {
              this.$message({
                type: 'warning',
                message: '未知账号'
              })
            }
          }
        })
      } else {
        this.$message({
          type: 'warning',
          message: '请输入账号、密码'
        })
      }
    }

  }
}
</script>

<style lang="less" scoped>
.login {
  width: 100%;
  height: 100%;
  padding: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 0 !important;
  user-select: none;
  background-image: url("~@imgs/login/bg.png");
  background-position: center center;
  background-size: cover;
  background-attachment: scroll;
}

.login_inner {
  width: var(--width);
  height: 7.5rem;
  position: relative;
  background-color: #ffffff;
  border-radius: 0.1rem;
  overflow: hidden;
  display: flex;
  box-shadow: 1px 0px 8px -5px #000;

  .l_inner,
  .r_inner {
    height: 100%;
  }

  // 图片框
  .l_inner {
    width: 7rem;
    background: url('~@imgs/login/login_bg.png') no-repeat center center;
    background-size: cover;
  }

  // 登录框
  .r_inner {
    .item_box {
      height: 100%;
      width: 6rem;
      box-sizing: border-box;
      padding: 1rem;
    }

    .item_box h3 {
      font-size: 0.38rem;
      color: #317CFF;
      margin: 0 0 0.2rem 0;
      letter-spacing: 4px;
    }

    .item_box h4 {
      font-size: 0.16rem;
      font-weight: 400;
      color: #c9cbd1;
      margin-bottom: 0.6rem;
    }

    .item_box h5 {
      font-size: 0.32rem;
      color: #317CFF;
      margin: .3rem 0 0.7rem 0;
      letter-spacing: 2px;
      font-weight: bold;
    }

    // 登录项
    .item_box .item,
    .item_box .item input,
    .item_box button {
      width: 100%;
    }

    .item_box .item {
      display: flex;
      align-items: center;
      overflow: hidden;
      border-radius: 5px;
      height: 0.6rem;
      margin-top: 0.32rem;
      box-sizing: border-box;
      border: 1px solid #DEDEDE;
    }

    .item_box .icon {
      margin-left: 0.22rem;
      width: 0.2rem;
      height: 0.2rem;
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
      opacity: 0.8;

      &.icon-user {
        background-image: url('~@imgs/login/icon-user.png');
      }

      &.icon-password {
        background-image: url('~@imgs/login/icon-password.png');
      }
    }

    .item_box .item input {
      display: block;
      height: 100%;
      border: 0;
      font-size: 0.17rem;
      padding: 0 0.18rem;
      outline: none;
      color: #333;
      letter-spacing: 1px;
			
			&:-webkit-autofill {
				transition: background-color 50000s ease-in-out 0s;
			}
			
			&::-moz-placeholder {
			  color: #b6b6b6;
			}
			
			&:-ms-input-placeholder {
			  color: #b6b6b6;
			}
			
			&::-webkit-input-placeholder {
			  color: #b6b6b6;
			}
    }

    .handle_inner {
      margin-top: 0.2rem;
    }

    // 登录按钮
    .login_btn {
      background-color: #317CFF;
      color: #fff;
      height: 0.55rem;
      margin-top: 0.9rem;
      font-size: 0.18rem;
      border-radius: 0.05rem;
    }

    // 返回首页
    .home_inner {
      text-align: center;
      margin-top: 1.5rem;
      font-size: 0.15rem;
      color: var(--color3);

      span {
        cursor: pointer;
      }
    }
  }
}
</style>
